// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"445e77fb","188":"445e77fb","245":"445e77fb","389":"445e77fb","400":"445e77fb","528":"445e77fb","536":"445e77fb","580":"445e77fb","708":"445e77fb","748":"445e77fb","832":"445e77fb","960":"445e77fb","984":"445e77fb"}[chunkId] + ".chunk.css";
};